import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, MessageSquareIcon, ShieldIcon, BatteryIcon, BriefcaseIcon, HeartIcon } from 'lucide-react';
const cards = [{
  icon: SearchIcon,
  title: 'Detectar manipuladores',
  desc: 'Reconocé señales y patrones antes de que te desgasten emocionalmente.'
}, {
  icon: MessageSquareIcon,
  title: 'Responder sin explotar',
  desc: 'Aprendé a reaccionar con más claridad y menos ansiedad.'
}, {
  icon: ShieldIcon,
  title: 'Poner límites',
  desc: 'Decí "no" sin culpa y protegé tu bienestar emocional.'
}, {
  icon: BatteryIcon,
  title: 'Dejar de absorber problemas ajenos',
  desc: 'Recuperá energía mental y tranquilidad.'
}, {
  icon: BriefcaseIcon,
  title: 'Manejar jefes y personas difíciles',
  desc: 'Herramientas prácticas para ambientes tensos.'
}, {
  icon: HeartIcon,
  title: 'Proteger tu energía mental',
  desc: 'Menos tensión. Más calma. Más claridad.'
}];
export function WhatYouLearn() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-384" data-mp="34pkec7k4gchv">
      <div className="max-w-6xl mx-auto" data-id="element-385" data-mp="2zqze484vdstf">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-386" data-mp="2zs10v9v903qz">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-387" data-mp="2h086pc4g0cho">
            <span className="text-xs font-bold tracking-widest" data-id="element-388" data-mp="2c2py5muc7za7">
              🌸 QUÉ VAS A APRENDER
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight max-w-3xl mx-auto" data-id="element-389" data-mp="274enj9w7xkqx">
            Habilidades reales que{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-390" data-mp="5bqgepgged5v">
              se notan
            </span>{' '}
            en tu día a día
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-391" data-mp="24ixf106c4ii7">
          {cards.map((c, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07,
          duration: 0.5
        }} whileHover={{
          y: -4
        }} className="bg-white p-7 rounded-3xl border border-line shadow-sm hover:shadow-lg transition-shadow" data-id="element-392" data-mp="1puua7u413cuz" data-mpi={i}>
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5 bg-rose/10" data-id="element-393" data-mp="y0s89e9ca6bz">
                <c.icon className="w-6 h-6 text-rose" data-id="element-394" data-mp="121kh46eau97q" />
              </div>
              <h3 className="font-serif text-xl md:text-2xl text-ink mb-2 leading-tight font-bold" data-id="element-395" data-mp="uiuovrnmcuvn">
                {c.title}
              </h3>
              <p className="text-ink-soft text-sm leading-relaxed" data-id="element-396" data-mp="14ibts6v1r4qk">{c.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}